import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceipt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5.75 6.25h4.5m-4.5 6.5h4.5M5.75 9.5h4.5m3.5-1.75V3.5a1.75 1.75 0 1 1 3.5 0v3.85c0 .14 0 .21-.027.264a.25.25 0 0 1-.11.109c-.053.027-.123.027-.263.027h-3.1Zm0 0v10.5L11 16.75l-3 1.5-3-1.5-2.5 1.5V3.5c0-.966.784-1.75 1.75-1.75h11"
	})]
});
const ForwardRef = forwardRef(SvgReceipt);
export { ForwardRef as ReactComponent };
